import {ToastaService} from 'ngx-toasta';
import {Injectable} from '@angular/core';
import {TranslateService} from '@ngx-translate/core';
import {Store} from "@ngrx/store";

@Injectable({
  providedIn: 'root'
})
export abstract class AbstractDetailsAction {

  protected constructor(
    protected translateService: TranslateService,
    protected toastaService: ToastaService,
    protected store: Store
  ) {
  }

  protected _dispatchType(action: any): void {
    this.store.dispatch(action);
  }

  protected _dispatchSuccess(action: any): void {
    this.store.dispatch(action);
  }

  protected _dispatchFail(action: any, showToasta = true): void {
    this.store.dispatch(action);
    const unknownErrorMessage = this.translateService.instant('ERRORS.unknown' );
    console.error('abstractDetails Action, _dispatchFail, '+unknownErrorMessage,action);
    if (showToasta) {
      this.toastaService.error(unknownErrorMessage);
    }
  }
}
